import React from 'react';
import { PageLoader } from 'src/lib/PageLoader';

export const AsyncRegisterPage = ({ ...props }): JSX.Element => (
  <PageLoader
    id='src/pages/RegisterPage/RegisterPage'
    componentImport={async () => (await import('src/pages/RegisterPage/RegisterPage'))}
    head={() => async () => {
      return {
        title: 'Create Account',
        description: 'Create Your Account With Rock Island Auction Company',
      };
    }}
    {...props}
  />
);
